/* Catching a referral link, and carrying it as far as the order.

   A friend arrives at any page with ?ref=CODE. That code has to survive every
   click between landing and checkout, so it is not held in the URL: it goes to
   localStorage, and from there onto the cart as an attribute. Shopify copies
   cart attributes onto the order, which is how the backend's orders/paid
   webhook comes to see it without a discount code ever being minted.

   The browser sets this, so it is not proof of anything — and the backend does
   not treat it as proof. It decides *which* referrer to look up and nothing
   else; whether money moves is settled against the order Shopify signed.
*/
(function () {
  'use strict';

  var KEY = 'toms:ref';
  var APPLIED = 'toms:ref-applied';
  /* Longer than anyone browses and shorter than a code stays interesting. A
     referral honoured a year after the click is somebody's forgotten tab. */
  var DAYS = 30;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return '';
      var held = JSON.parse(raw);
      if (!held || !held.code || Date.now() > held.until) {
        localStorage.removeItem(KEY);
        return '';
      }
      return held.code;
    } catch (e) { return ''; }
  }

  function remember(code) {
    try {
      localStorage.setItem(KEY, JSON.stringify(
        { code: code, until: Date.now() + DAYS * 86400000 }));
      sessionStorage.removeItem(APPLIED);
    } catch (e) { /* private browsing; the link still works this session */ }
  }

  var params = new URLSearchParams(window.location.search);
  var incoming = (params.get('ref') || '').trim().toUpperCase().slice(0, 32);
  /* The codes are drawn from a fixed alphabet, so anything else was not one of
     ours and is not worth storing, let alone sending. */
  if (incoming && /^[2-9A-HJ-NP-Z]{4,32}$/.test(incoming)) remember(incoming);

  var code = read();
  if (!code) return;

  /* Once per session. Cart attributes persist on the cart, so re-posting on
     every page load would be a request per page for no change. */
  try {
    if (sessionStorage.getItem(APPLIED) === code) return;
  } catch (e) { /* no sessionStorage: post once per page, which still works */ }

  var routes = (window.MagicStore && window.MagicStore.routes) || {};
  fetch(routes.cart || '/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      /* Never overwrite a code already on the cart. Whoever got there first
         sent the shopper here; a later link should not take the credit. */
      if (cart && cart.attributes && cart.attributes.ref) {
        try { sessionStorage.setItem(APPLIED, cart.attributes.ref); } catch (e) {}
        return null;
      }
      return fetch(routes.cart_update || '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { ref: code } })
      });
    })
    .then(function (response) {
      if (response) {
        try { sessionStorage.setItem(APPLIED, code); } catch (e) {}
      }
    })
    .catch(function () {
      /* Silent. A referral that does not attach is a missed reward, not a
         broken page, and there is nothing the shopper could do about it. */
    });
}());

/* Creator link pages (2026-10-05). A visit to theonlinemagicstore.com/<slug>
   lands on /pages/link?c=<slug>, which this layout loads too, so the slug is
   held from the first view. It goes on the cart as the `creator` attribute, apart from a
   friend's `ref`. Rich's rules: a click counts for 30 days (10-15; was 90), and the latest
   creator link wins (unlike `ref`, where the first code holds). As with ref,
   the backend (links.creator_for_order) decides whether anything is paid. */
(function () {
  'use strict';

  var KEY = 'toms:creator';
  var APPLIED = 'toms:creator-applied';
  var DAYS = 30;

  function read() {
    try {
      var held = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!held || !held.slug || Date.now() > held.until) {
        localStorage.removeItem(KEY);
        return '';
      }
      return held.slug;
    } catch (e) { return ''; }
  }

  var incoming = (new URLSearchParams(window.location.search).get('c') || '').trim().toLowerCase();
  var slug = '';
  if (/^[a-z0-9][a-z0-9-]{1,30}$/.test(incoming)) {
    slug = incoming;
    try {
      localStorage.setItem(KEY, JSON.stringify({ slug: slug, until: Date.now() + DAYS * 86400000 }));
    } catch (e) { /* private browsing; this session still carries it */ }
  } else {
    slug = read();
  }
  if (!slug) return;

  try {
    if (sessionStorage.getItem(APPLIED) === slug) return;
  } catch (e) {}

  var routes = (window.MagicStore && window.MagicStore.routes) || {};
  fetch(routes.cart || '/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart && cart.attributes && cart.attributes.creator === slug) return true;
      return fetch(routes.cart_update || '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { creator: slug } })
      });
    })
    .then(function (done) {
      if (done) { try { sessionStorage.setItem(APPLIED, slug); } catch (e) {} }
    })
    .catch(function () {});
}());
